import { ApiArrayGetter, apiService } from "@/services/api/apiService";
import { enhanceObjectCopy, isNotNullObject } from "@/helpers/units";

export class LabsResearch {
  // /**
  //  * Название услуги или общего исследования (может быть группирующим)
  //  */
  // srvtext: string | null = null; //  "Определение основных групп крови (A, B, 0) ";
  //
  // /**
  //  * Номер заказа (направления) на исследование
  //  */
  // order_num: string | null = null; //  "2512220031847501";
  //
  // /**
  //  * Внутренний идентификатор записи анализа
  //  */
  // ids: string | null = null; //  "256918";
  //
  // /**
  //  * Тип биоматериала (образца)
  //  */
  // specimen_text: string | null = null; //  "Венозная кровь";
  //
  // /**
  //  * Дата и время регистрации заказа в системе
  //  */
  // regdate: string | null = null; //  "2025-12-22T05:53:00.000Z";
  //
  // /**
  //  * Идентификатор заголовка (группы анализов)
  //  */
  // title_id: number | null = null; //  1;
  //
  // /**
  //  * Название заголовка (группы)
  //  */
  // title: string | null = null; //  null;
  //
  // /**
  //  * Порядок отображения результата внутри группы
  //  */
  // res_display_order: number | null = null; //  2;
  //
  // /**
  //  * Название конкретного теста (анализа)
  //  */
  // test_name: string | null = null; //  "Группа крови";
  //
  // /**
  //  * Результат анализа (значение)
  //  */
  // value: string | null = null; //  "A(II)";
  //
  // /**
  //  * Примечание к значению (например, особенности интерпретации)
  //  */
  // value_note: string | null = null; //  null;
  //
  // /**
  //  * Единица измерения (для количественных тестов)
  //  */
  // unit: string | null = null; //  null;
  //
  // /**
  //  * Референсные значения (норма) в текстовом виде
  //  */
  // norm: string | null = null; //  "-";
  //
  // /**
  //  * Уровень патологии (интерпретация: выше/ниже нормы)
  //  */
  // pat_level: string | null = null; //  null;
  //
  // /**
  //  * Нижняя граница нормы (числовое значение)
  //  */
  // norm_min: string | null = null; //  null;
  //
  // /**
  //  * Верхняя граница нормы
  //  */
  // norm_max: string | null = null; //  null;
  //
  // /**
  //  * Примечание к референсным значениям
  //  */
  // norm_note: string | null = null; //  null;
  //
  // /**
  //  * Предыдущий результат (для отслеживания динамики)
  //  */
  // last_res: string | null = null; //  null;
  //
  // /**
  //  * Дата предыдущего результата (вероятно, опечатка, должно быть date_last_res)
  //  */
  // data_last_res: string | null = null; //  null;
  //
  // /**
  //  * Название бактерии (для микробиологических исследований)
  //  */
  // abio_bactery_text: string | null = null; //  null;
  //
  // /**
  //  * Код сортировки бактерии
  //  */
  // abio_bactery_sortcode: string | null = null; //  null;
  //
  // /**
  //  * Колониеобразующие единицы (КОЕ) — количественная оценка роста бактерий
  //  */
  // abio_koe: string | null = null; //  null;
  //
  // /**
  //  * Результат по бактерии (например, чувствительность/устойчивость)
  //  */
  // res_bactery_text: string | null = null; //  null;
  //
  // /**
  //  * Название антибиотика (в антибиотикограмме)
  //  */
  // res_antibiotic_text: string | null = null; //  null;
  //
  // /**
  //  * Код сортировки результата (возможно, внутренний)
  //  */
  // res_sortcode: string | null = null; //  null;
  //
  // /**
  //  * Интерпретация чувствительности к антибиотику:
  //  * S — чувствителен, I — промежуточно, R — устойчив.
  //  * Значение "N" может означать "не тестировалось" или "норма".
  //  */
  // res_sir: string | null = null; //  "N";
  //
  // /**
  //  * Минимальная ингибирующая концентрация (MIC) — количественный показатель чувствительности
  //  */
  // res_mic: string | null = null; //  null;
  //
  // /**
  //  * Диаметр зоны ингибиции (для диско-диффузионного метода)
  //  */
  // res_dia: string | null = null; //  null;
  //
  // /**
  //  * Заключение по антибиотикограмме (например, "чувствителен к...")
  //  */
  // abio_conclusion: string | null = null; //  null;
  //
  // /**
  //  * Примечание к антибиотикограмме
  //  */
  // abio_note: string | null = null; //  null;
  //
  // /**
  //  * Источник финансирования (например, договор, ОМС, ДМС)
  //  */
  // fin: string | null = null; //  "Договоры";
  //
  // /**
  //  * Дата и время взятия биоматериала
  //  */
  // collectdate: string | null = null; //  "2025-12-22T07:08:21.000Z";
  //
  // /**
  //  * Дата и время окончания анализа (готовности результата)
  //  */
  // finishdate: string | null = null; //  "2025-12-22T07:19:01.000Z";
  //
  // /**
  //  * ФИО сотрудника, выполнившего анализ
  //  */
  // exec_man: string | null = null; //  "Османова Надежда Герасимовна";
  //
  // /**
  //  * ФИО сотрудника, утвердившего результат (валидатора)
  //  */
  // valid_man: string | null = null; //  "Османова Надежда Герасимовна";
  // не рабочее апи
  research_id: number | null = null;
  ext_results	: number | null = null;
  internal_order: number | null = null;
  text_status: string | null = null;
  specimen	: string | null = null;
  regdate	: string | null = null;

  constructor(rawData: Record<string, unknown> = {}) {
    enhanceObjectCopy(rawData, this as Record<string, unknown>);
  }
}

export const API_Labs_research = ApiArrayGetter<
  { researchid: string },
  LabsResearch
>(
  {
    endpoint: "/labs/research",
    method: "get",
  },
  LabsResearch
);
